// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__c_Qw6","inner":"Form_inner__1Ps4f","range":"Form_range__3TqxO","name":"Form_name__21ViI","actions":"Form_actions__1uwaM"};